// src/pages/Dashboard/Admin/Messages/MessagesDashboard.jsx

import React, { useMemo } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useScrollToTop from "../../../../hooks/useScollToTop";
import { useUser } from "../../../../pages/Home/UserContext";
import { getUserRoleId } from "../../../config/dashboardMenuConfig";

import { useMessagesDashboard } from "./hooks/useMessagesDashboard";

import DashboardMessagesHeader from "./components/DashboardMessagesHeader";
import MessagesKpiCards from "./components/MessagesKpiCards";
import MessagesFiltersCard from "./components/MessagesFiltersCard";
import MessagesUnifiedList from "./components/MessagesUnifiedList";
import MessageDetailsDrawer from "./components/MessageDetailsDrawer";

function getStoredUserInfo() {
  try {
    const raw = localStorage.getItem("userInfo");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function UnauthorizedMessagesPanel() {
  return (
    <section className="w-full pb-10 pt-5 font-satoshi">
      <div className="mx-auto max-w-[1400px] px-3 sm:px-4 lg:px-6">
        <div className="overflow-hidden rounded-[28px] border border-rose-200 bg-white shadow-sm dark:border-rose-500/20 dark:bg-slate-900">
          <div className="h-1.5 bg-gradient-to-r from-rose-500 to-orange-500" />

          <div className="p-5 sm:p-6">
            <p className="text-[11px] uppercase tracking-[0.22em] text-rose-500">
              Accès refusé
            </p>

            <h1 className="mt-1 text-2xl font-bold text-slate-900 dark:text-white">
              Messages & discussions
            </h1>

            <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-600 dark:text-slate-300">
              Cette page est réservée aux administrateurs du club.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function MessagesDashboard() {
  useScrollToTop();

  const { user } = useUser();
  const storedUser = useMemo(() => getStoredUserInfo(), []);
  const roleId = getUserRoleId(user || storedUser);

  const dashboard = useMessagesDashboard();

  if (roleId !== 1) {
    return <UnauthorizedMessagesPanel />;
  }

  return (
    <section className="w-full pb-10 pt-5 font-satoshi">
      <div className="mx-auto max-w-[1400px] space-y-5 px-3 sm:px-4 lg:px-6">
        <DashboardMessagesHeader
          loading={dashboard.loading}
          onRefresh={dashboard.fetchAll}
        />

        <MessagesKpiCards
          stats={dashboard.stats}
          filteredStats={dashboard.filteredStats}
          loading={dashboard.loading}
        />

        <MessagesFiltersCard
          filters={dashboard.filters}
          setFilter={dashboard.setFilter}
          resetFilters={dashboard.resetFilters}
          groups={dashboard.groups}
          subjects={dashboard.subjects}
          filteredCount={dashboard.filteredMessages.length}
          totalCount={dashboard.unifiedMessages.length}
          loading={dashboard.loading}
          onRefresh={dashboard.fetchAll}
        />

        <MessagesUnifiedList
          messages={dashboard.filteredMessages}
          loading={dashboard.loading}
          deletingKey={dashboard.deletingKey}
          onOpenDetails={dashboard.openDetailsDrawer}
          onDelete={dashboard.deleteMessage}
        />
      </div>

      <MessageDetailsDrawer
        isOpen={dashboard.detailsDrawerOpen}
        message={dashboard.detailsMessage}
        deletingKey={dashboard.deletingKey}
        onClose={dashboard.closeDetailsDrawer}
        onDelete={dashboard.deleteMessage}
      />

      <ToastContainer />
    </section>
  );
}